export default __webpack_public_path__ + "static/media/IskoolaPota.982381c7.woff2";